
export default {
  name: 'UsageRecordDetails',
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  computed: {
    producerLabel () {
      const producer = this.related('contacts', this.formData.producer)
      return producer?.display_name || producer?.full_name || producer?.company || producer?.name || this.fallback(this.formData.producer)
    },
    farmunitLabel () {
      const farmunit = this.related('farmunits', this.formData.farmunit)
      return farmunit?.unit_id || farmunit?.name || this.fallback(this.formData.farmunit)
    },
    diversionPointLabel () {
      const diversionPoint = this.related('diversionPoints', this.formData.diversionPoint)
      return diversionPoint?.name || this.fallback(this.formData.diversionPoint)
    }
  },
  methods: {
    related (storeName, value) {
      if (!value) {
        return null
      }
      if (typeof value === 'object') {
        return value
      }
      return this.$store.getters[`${storeName}/find`](value)
    },
    fallback (value) {
      if (!value) {
        return '--'
      }
      if (typeof value === 'object') {
        return value.name || value.unit_id || value.display_name || value.full_name || '--'
      }
      return value
    }
  }
}
